export default class {
	titulo
	idTipoDocumento
	idModeloDocumento
	idPedido
	idPenalidade
	constructor(id, titulo, idTipoDocumento, idModeloDocumento, idPenalidade) {
		this.idPedido = id
		this.titulo = titulo
		this.idTipoDocumento = idTipoDocumento
		this.idModeloDocumento = idModeloDocumento
		this.idPenalidade = idPenalidade
	}
}
